<template>
    <span class="badge px-4 user-select-none" :class="[type]">
        <i v-if="icon" class="mr-1" :class="[icon]"/>
        <slot name="icon" />
        <slot/>
    </span>
</template>

<script>
export default {
    props: {
        icon: String,
        type: {
            type: String,
            default: 'badge-secondary text-muted'
        }
    }
}
</script>
